import React from "react";
import { C, font, mono } from "../config/theme";
import { fmt } from "../utils/format";

export default function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div
      style={{
        background: C.navy, borderRadius: 8, padding: "10px 14px", color: "#fff",
        fontSize: 12, fontFamily: font, boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 6 }}>{label}</div>
      {payload.map((p, i) => (
        <div key={i} style={{ display: "flex", justifyContent: "space-between", gap: 16, marginBottom: 2 }}>
          <span style={{ color: p.color }}>{p.name}</span>
          <span style={{ fontFamily: mono, fontWeight: 600 }}>{fmt(p.value)}</span>
        </div>
      ))}
    </div>
  );
}
